import i18n from "locales/i18n";
import { JSX, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import * as constent from "util/constent";

/********************* */

// 이메일

export const regEmail =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}/;
// 영문 + 숫자 + 특수 문자
export const regPassword = /^(?=.*(a-zA-Z)(?=.*[0-9])(?=.*[!@#$%^*]).{8,20})/;

export const englishRegex = /[A-Za-z]/; //영문만 ^ +$
export const numberRegex = /[0-9]/; // 숫자만
export const numRegex = /^\d*$/; // 숫자만

export const specialCharRegex = /[!@#$%^*]/; // 특수문자만

export const passwordRegex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^*])[A-Za-z\d!@#$%^*]{8,20}$/; // 영문 +숫자 + 특수문자(!@#$%^*) + 8 ~ 12자 이내
export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/; //이메일

export const phoneRegex = /^01[016789]-?\d{3,4}-?\d{4}$/; // 하이픈 포함 / 미 포함

/********************  FORMATTER        *************/
export const dateFormat = (date: string, sign = "-") => {
  const format = date?.replace(
    /^(\d{0,4})(\d{0,2})(\d{0,2})$/g,
    `$1${sign}$2${sign}$3`
  );

  return format;
};

export const priceFormat = (price: string | number) => {
  if (!(price + "")) {
    return;
  }

  const langCd = i18n.language;
  if (langCd === "ko") {
    return "₩" + price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "";
  }
  if (langCd === "en") {
    return "$" + price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const isEmpty = (params: any) => {
  return Object.values(params).length === 0;
};

export const timeFormat = (time: string | number) => {
  return (time + "").replace(/\B(?=(\d{2})+(?!\d))/g, ":") || "-";
};

export const getYears = (num: number) => {
  const year = new Date().getFullYear();

  const prevYear = Array.from({ length: 10 }, (_, i) => {
    return {
      ko: year - i + "년",
      en: year - i,
      value: year - i,
      code: year - i,
    };
  });
  const nextyear = Array.from({ length: 10 }, (_, i) => {
    return {
      ko: year + i + "년",
      en: year + i,
      value: year + i,
      code: year + i,
    };
  });

  const yearOption = [...prevYear.reverse(), ...nextyear];

  return yearOption;
};

export const getTdy = () => {
  const tdy = new Date().toLocaleString("ko-KR").split(".");
  const tmrrw = new Date(new Date().setDate(new Date().getDate() + 1))
    .toLocaleString("ko-KR")
    .split(".");

  //     const num = 2;
  // const formatted = String(num).padStart(2, '0');

  return {
    tdy:
      tdy[0] +
      ("00" + tdy[1].replace(" ", "")).slice(-2) +
      ("00" + tdy[2].replace(" ", "")).slice(-2),
    tmrrw:
      tmrrw[0] +
      ("00" + tmrrw[1].replace(" ", "")).slice(-2) +
      ("00" + tmrrw[2].replace(" ", "")).slice(-2),
  };
};

export const diffDate = (dates: string[]) => {
  if (!dates) {
    return 0;
  }

  const start = `${dates[0]}`.replace(
    /^(\d{0,4})(\d{0,2})(\d{0,2})$/g,
    "$1/$2/$3"
  );

  const end = `${dates.at(-1)}`.replace(
    /^(\d{0,4})(\d{0,2})(\d{0,2})$/g,
    "$1/$2/$3"
  );

  const diffDate = new Date(end).getTime() - new Date(start).getTime();

  return Math.abs(diffDate / (1000 * 60 * 60 * 24));
};

// 년, 월, 일 , 요일
export const fullDateFormat = (
  dateStr: string | number | Date,
  weekday?: boolean,
  time?: Boolean
) => {
  const formattedStr = dateFormat(dateStr + "");
  const date = new Date(formattedStr);

  const langCd = i18n.language;

  // 시간 부분 직접 추출
  const timeKorea = new Date(
    date.toLocaleString("en-US", { timeZone: "Asia/Seoul" })
  );
  const hour = String(timeKorea.getHours()).padStart(2, "0");
  const minute = String(timeKorea.getMinutes()).padStart(2, "0");

  if (langCd === "ko") {
    const datePart = date.toLocaleDateString("ko-KR", {
      timeZone: "Asia/Seoul",
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: weekday ? "long" : undefined,
      // hour: time ? "2-digit" : undefined,
      // minute: time ? "2-digit" : undefined,
      // hour12: false,
    });
    const finnal = time ? datePart + " / " + hour + ":" + minute : datePart;
    return finnal;
  }
  if (langCd === "en") {
    const datePart = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: weekday ? "long" : undefined,
      // hour: time ? "2-digit" : undefined,
      // minute: time ? "2-digit" : undefined,
      // hour12: false,
    });
    const finnal = time ? datePart + " / " + hour + ":" + minute : datePart;
    return finnal;
  }
  if (langCd === "ja") {
    const datePart = date.toLocaleDateString("ja-JP", {
      timeZone: "Asia/Seoul",
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: weekday ? "long" : undefined,
      // hour: time ? "2-digit" : undefined,
      // minute: time ? "2-digit" : undefined,
      // hour12: false,
    });
    const finnal = time ? datePart + " / " + hour + ":" + minute : datePart;
    return finnal;
  }
};

export const getDurationDate = (startStr: string, endStr: string) => {
  const diffDays = diffDate([startStr, endStr]); // 총일수

  const nights = diffDays; // 보통 호텔 등에서는 '1박 2일' 기준 → 1박 = 2일
  const days = nights + 1;

  const langCd = i18n.language;

  if (langCd === "ko") {
    return `${nights}박 ${days}일`;
  }

  if (langCd === "en") {
    // return `${nights} night(s) and ${days} day(s)`;
    return `${nights} night`;
  }

  if (langCd === "ja") {
    return `${nights}泊${days}日`;
  }
};

/***************** CHECKBOX CHAGE CONTROL *********/

type ICheckbox = {
  checked: boolean;
  parent: any;
  essYn?: boolean;
  type: "all" | "item";
};

export const checkBoxChange = ({ checked, parent, type, essYn }: ICheckbox) => {
  const checkeds = parent.querySelectorAll(
    'input[type="checkbox"]'
  ) as NodeListOf<HTMLInputElement>;

  const [allCheck, ...items] = Array.from(checkeds);

  let isAllCheck = Array.from(items).every((checkBox) => {
    return checkBox.checked;
  });

  if (type === "all") {
    Array.from(checkeds).forEach((checkBox) => {
      checkBox.checked = checked;
    });
  }

  if (type === "item") {
    allCheck.checked = isAllCheck;
  }
};

/***************** SUCCESS CONTROL *********/
type ISuccess = {
  status: any;
  success(): void;
};

export const successControl = ({ status, success }: ISuccess) => {
  const { code, message } = status;
  if (code === 0) {
    success();
  }
  if (code === -1) {
    alertControl({
      isOpen: true,
      inner: message,
    });
  }
  if (code === -200) {
    return alertControl({
      isOpen: true,
      inner: "로그인하여 주세요",
    });
  }
};

/*****************MODAL CONTROLER  *********/

type IModal = {
  isOpen?: boolean;
  ttl?: string;
  chckBtn?: boolean;
  btnTxt?: string;
  disabled?: boolean;
  keep?: boolean;
  inner?: ReactNode | JSX.Element;
  styles?: string;
  click?: () => void;
};
export const modalControl = ({
  isOpen,
  ttl,
  chckBtn = true,
  btnTxt,
  disabled,
  keep,
  inner,
  styles,
  click,
}: IModal) => {
  const modalControlEvent = new CustomEvent(constent.CONST_COMM_MODAL_CONTROL, {
    detail: {
      isOpen,
      ttl,
      chckBtn,
      btnTxt,
      disabled,
      inner,
      keep,
      styles: styles ?? "",
      click,
    },
  });

  window.dispatchEvent(modalControlEvent);
};

/*****************ALERT CONTROLER  *********/

type IAlert = {
  isOpen?: boolean;
  inner?: string;
  innerHtml?: any;
  cncl_btn?: boolean;
  chk_btn?: boolean;
  chk_text?: string;
  dplc?: boolean;
  click?(): void;
  cnlClick?(): void;
};

export const alertControl = ({
  isOpen,
  inner,
  innerHtml,
  chk_text,
  cncl_btn,
  chk_btn = true,
  click,
  cnlClick,
  dplc,
}: IAlert) => {
  //CONST_COMM_ALERT_CONTROL
  const alertControlEvent = new CustomEvent(constent.CONST_COMM_ALERT_CONTROL, {
    detail: {
      isOpen,
      inner,
      innerHtml,
      cncl_btn,
      chk_text,
      chk_btn,
      dplc,
      click,
      cnlClick,
    },
  });

  window.dispatchEvent(alertControlEvent);
};

/*****************LOADING CONTROLER  *********/

type ILoad = {
  isLoading: boolean;
  text?: string;
};
export const loadControl = ({ isLoading, text }: ILoad) => {
  const loadControlEvent = new CustomEvent(constent.CONST_COMM_LOAD_CONTROL, {
    detail: {
      isLoading,
      text,
    },
  });

  window.dispatchEvent(loadControlEvent);
};

/**************** SECCION TIMEOUT **************/
export const sessionTimeOut = () => {
  const sessionTimeOutEvent = new CustomEvent(
    constent.CONST_COMN_SESSION_TIME_OUT,
    {
      detail: {
        isLogin: false,
      },
    }
  );

  window.dispatchEvent(sessionTimeOutEvent);
};
